<template>
  <span class="wm_warning_label">
    <slot />
  </span>
</template>
